<template>
    <div class="common-list">
        <topBanner>
            <template v-slot:list-name>{{listName}}<div class="list-name-memo"></div></template>
            <template v-slot:list-memo>{{listMemo}}</template>
        </topBanner>
        <div><list :listHeader='listHeader' :listUnit='listUnit' :listData='listData'></list></div>
    </div>
</template>

<script>
export default {
    name: 'commonList',
    components: {
        topBanner: (resolve) => {require(["../components/list-header"],resolve)},
        list: (resolve) => {require(["../components/list"], resolve)}
    },
    data(){
        return {
            listHeader: '上市至今涨幅',
            listUnit: '%',
            listMemo:"",
            listName:"",
            listData:[
                {rank:1,name:'云锋金融',code:'00376',market:'HK',value:'230'},
                {rank:2,name:'云锋金融',code:'00376',market:'HK',value:'230'},
                {rank:3,name:'云锋金融',code:'00376',market:'HK',value:'230'},
                {rank:4,name:'云锋金融',code:'00376',market:'HK',value:'230'},
                {rank:5,name:'云锋金融',code:'00376',market:'HK',value:'230'},
                {rank:6,name:'云锋金融',code:'00376',market:'HK',value:'230'},
                {rank:7,name:'云锋金融',code:'00376',market:'HK',value:'230'},
                {rank:8,name:'云锋金融',code:'00376',market:'HK',value:'230'},
                {rank:9,name:'云锋金融',code:'00376',market:'HK',value:'230'},
                {rank:10,name:'云锋金融',code:'00376',market:'HK',value:'230'},
                {rank:11,name:'云锋金融',code:'00376',market:'HK',value:'230'},
                {rank:12,name:'云锋金融',code:'00376',market:'HK',value:'230'},
            ]
        }
    },
    methods: {
        getQuery: function(name){
            let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            let r = window.location.search.substr(1).match(reg);
            if (r != null) {
                return decodeURIComponent(r[2]);
            };
            return null;
        }
    },
    created(){
        let attr2 = "{tracking_type:view, event_id:yfyy_ipo_list_common_"+this.getQuery("dimension")+"}";
        document.getElementsByTagName("body")[0].setAttribute("yybp",attr2);
        let url = location.protocol+"//"+location.hostname+"/api/youyu-ipo-list/list";
        this.$http.get(url,{params:{
            startDate:this.getQuery("startDate"),
            endDate: this.getQuery("endDate"),
            dimension: this.getQuery("dimension")
        }}).then((response)=>{
            // console.log(response.data);
            this.listHeader = response.data.data.listHeader;
            this.listUnit = response.data.data.unit;
            this.listName = response.data.data.ch;
            this.listMemo = response.data.data.memo;
            this.listData = response.data.data.data;
            if (this.listUnit === "%"){
                for (let i=0; i<this.listData.length; i++){
                    this.listData[i].value = (this.listData[i].value * 100).toFixed(2);
                    this.listData[i].rank = i + 1;
                }
            } else {
                for (let i=0; i<this.listData.length; i++){
                    this.listData[i].value = (this.listData[i].value).toFixed(2);
                    this.listData[i].rank = i + 1;
                }
            }
        })
    }
}
</script>



<style lang="scss" scoped>
.common-list {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    text-align: center;
    background: #fff;
}

.list-name-memo {
    font-size: .3rem;
}
</style>